import React, { useEffect, useState } from "react";

import { Tooltip } from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";

import { DataTrackMessage } from "../../../../constants";
import { useVideoSurveyInventory } from "../../../../hooks/useVideoSurveyInventory";
import Button, { Color } from "../../../Form/Button";
import useLocalVideoToggle from "../../hooks/useLocalVideoToggle/useLocalVideoToggle";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import LeaveModal from "../../LeaveModal";

const useStyles = makeStyles(() =>
  createStyles({
    leaveButton: {
      padding: "9px 20px",
      height: "fit-content",
    },
  })
);

export default function EndCallButton() {
  const classes = useStyles();
  const { room, dataTrack, isFinished, setIsFinished } = useVideoContext();
  const { updateQuoteInventory, setUpdateEnabled } = useVideoSurveyInventory();
  const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
  const { t: translate } = useTranslation();

  const [openLeaveVideoSurveyModal, setOpenLeaveVideoSurveyModal] = useState<boolean>(false);

  useEffect(() => {
    if (isFinished) room?.disconnect();
  }, [isFinished]);

  const onLeaveVideoSurvey = () => {
    if (isVideoEnabled) toggleVideoEnabled();
    updateQuoteInventory();
    setUpdateEnabled(false);
    dataTrack.send(DataTrackMessage.SHIPEEZI_FINISHED);
    setIsFinished(true);
  };

  return (
    <>
      <LeaveModal
        open={openLeaveVideoSurveyModal}
        setOpen={setOpenLeaveVideoSurveyModal}
        onLeaveVideoSurvey={onLeaveVideoSurvey}
      />

      <Tooltip title={translate("leaveVideoSurvey")}>
        <span>
          <Button
            customColor={Color.ERROR}
            className={classes.leaveButton}
            disabled={!room}
            onClick={() => setOpenLeaveVideoSurveyModal(true)}
            data-cy="leaveVideoSurveyButton"
            data-cy-disconnect
          >
            {translate("leave")}
          </Button>
        </span>
      </Tooltip>
    </>
  );
}
